// „MIND MEGNYITÁSA" — a kártya-fejléc EGYETLEN, egységes tovább-linkje a mögötte álló lista-oldalra.
//
// MIÉRT KOMPONENS (user-döntés): a link három kártyán szerepelt, mindenhol kézzel összeállított
// osztály-lánccal — így a méret/szín/ikon-térköz apró eltérései a fejléceket is elbillentették. Egy helyen
// definiálva a fejlécek magassága és a link tipográfiája garantáltan azonos.
//
// A FELIRAT is egy helyen dől el (`dashboard.openAll`): a hívó nem ad szöveget, tehát nem tud „Összes" és
// „Mind megnyitása" közt eltérni.
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * A kártya-fejléc jobb szélének EGYSÉGES akció-stílusa (szöveg-link/-gomb): ezt használja a „Mind megnyitása" és minden
 * fejléc-választó (pl. az Ünnepeltek ablaka) — így a fejléc magassága és a hover (szín-váltás, NINCS háttér) azonos.
 */
export const CARD_HEADER_ACTION_CLASS =
  'text-muted-foreground hover:text-foreground focus-visible:ring-ring flex shrink-0 items-center gap-1 rounded-sm text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2';

export interface CardOpenAllProps {
  /** A cél lista-oldal útvonala (literál a hívóban — a router típusa ezt kéri). */
  to: string;
  /** Opcionális szűrő-paraméterek (pl. a szűrt lista-nézet). */
  search?: Record<string, string>;
}

export function CardOpenAll({ to, search }: CardOpenAllProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Link
      // A típusos router-`to` szűkebb, mint a `string`; a hívók literált adnak, itt egy cast áll.
      to={to as never}
      search={search as never}
      className={CARD_HEADER_ACTION_CLASS}
    >
      {t('dashboard.openAll')}
      <ArrowRightIcon className="size-4" aria-hidden />
    </Link>
  );
}
